import { sanitizeDefaultPhraseHtml } from '@/util/html/sanitizeDefaultPhraseHtml';
import { sanitizeRichTextHtml } from '@/util/html/sanitizeRichTextHtml';
import { sanitizeHtml } from '@/util/html/sanitizeHtml';
import { sanitizePreviewHtml } from '@/util/html/sanitizePreviewHtml';

(function () {
  // モジュールの定義
  angular.module('inspinia', [
    // manage/js/ui-router/angular-ui-router.js
    // https://ui-router.github.io/ng1/docs/0.2.10/index.html#/api/ui.router
    'ui.router',
    // manage/js/plugins/uigrid/ui-grid.js
    // http://ui-grid.info/docs/#!/tutorial/Tutorial:%20101%20Intro%20to%20UI-Grid
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav',
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.pinning',
    // manage/js/plugins/oclazyload/dist/ocLazyLoad.js
    // https://oclazyload.readme.io/docs
    'oc.lazyLoad',
    // manage/js/bootstrap/ui-bootstrap-tpls-0.12.0.min.js
    // https://angular-ui.github.io/bootstrap/
    'ui.bootstrap',
    // Angular Translateの利用に必要
    // https://github.com/angular-translate/angular-translate
    // refs: https://mame0112.hatenablog.com/entry/2015/05/18/205920
    'pascalprecht.translate',
    // manage/js/angular/angular-cookies.js
    // https://docs.angularjs.org/api/ngCookies
    'ngCookies',
    // manage/js/plugins/ngFileUpload/ng-file-upload.js
    // https://github.com/danialfarid/ng-file-upload
    'ngFileUpload',
    // Angular Notify用のモジュールらしい
    // manage/js/plugins/angular-notify/angular-notify.js
    // https://github.com/cgross/angular-notify
    'cgNotify',
    // manage/js/plugins/datepicker/timepickerpop.js
    // https://github.com/mytechtip/timepickerpop
    'timepickerPop',
    // manage/js/plugins/angular-lazy-img/angular-lazy-img.min.js
    // https://github.com/Pentiado/angular-lazy-img
    'angularLazyImg',
    // manage/js/angular/angular-messages-1.4.8.min.js
    // https://docs.angularjs.org/api/ngMessages/directive/ngMessages
    'ngMessages',
    // manage/js/plugins/ui-sortable/sortable.js
    // https://github.com/angular-ui/ui-sortable
    'ui.sortable',
    // manage/js/angular/angular-sanitize.js
    // https://docs.angularjs.org/api/ngSanitize
    'ngSanitize',
  ]);

  const app = angular.module('inspinia');

  app
    .config([
      'datepickerConfig',
      'datepickerPopupConfig',
      'timepickerConfig',
      function (datepickerConfig, datepickerPopupConfig, timepickerConfig) {
        datepickerConfig.showWeeks = false; // 週番号（日本では馴染みが薄い）を非表示にする
        datepickerConfig.dayTitleFormat = 'yyyy年 MMMM';
        datepickerPopupConfig.datepickerPopup = 'yyyy年M月d日';
        datepickerPopupConfig.currentText = '本日';
        datepickerPopupConfig.clearText = '消去';
        datepickerPopupConfig.toggleWeeksText = '週番号';
        datepickerPopupConfig.closeText = '閉じる';
        timepickerConfig.showMeridian = false; // 時刻を24時間表示にする（デフォルトでは12時間表示）
      },
    ])
    .factory('Push', [
      function () {
        return Push;
      },
    ]);

  app.run(function (paginationConfig) {
    paginationConfig.firstText = '最初';
    paginationConfig.previousText = '前';
    paginationConfig.nextText = '次';
    paginationConfig.lastText = '最後';
  });

  app.constant('apiEndPoint', '/api/v2/admin/');
  app.constant('apiCommonEndPoint', '/api/v2/common/');
  app.constant('apiMessage', {
    apiInsertMessage: '作成しました',
    apiUpdateMessage: '更新しました',
    apiDeleteMessage: '削除しました',
  });

  // レガシー(manage/js)のサービスからも DOMPurify ラッパーを注入できるようにブリッジ登録する
  app.value('sanitizeDefaultPhraseHtml', sanitizeDefaultPhraseHtml);
  app.value('sanitizeRichTextHtml', sanitizeRichTextHtml);
  app.value('sanitizeHtml', sanitizeHtml);
  app.value('sanitizePreviewHtml', sanitizePreviewHtml);

  app
    .filter('getFileNameFromURI', function () {
      return function (value) {
        if (!angular.isString(value)) {
          return value;
        }
        try {
          return window.decodeURI(value.match('.+/(.+?)([?#;].*)?$')[1]);
        } catch (e) {
          return value;
        }
      };
    })
    .config(function ($translateProvider, apiCommonEndPoint) {
      let translationsApiIndexUrl = apiCommonEndPoint + 'translations/';
      $translateProvider.useUrlLoader(translationsApiIndexUrl);
      $translateProvider.fallbackLanguage('ja_JP');
      $translateProvider.preferredLanguage('ja_JP');
      $translateProvider.useLocalStorage();
      $translateProvider.useSanitizeValueStrategy('escape', 'sanitizeParameters');
    });

  app.factory('csrfTokenInjector', [
    '$q',
    function ($q) {
      return {
        request: function (config) {
          // フルパスの場合は除外する
          if (!config.url || config.url.startsWith('http://') || config.url.startsWith('https://')) {
            return config; // フルパスの場合はそのまま返す
          }

          // codmonに向いている場合は/api/v2, /api/v3, /api/v4 にパスが一致する場合のみtokenを送信する
          const tokenRequiredPath = [
            '/api/v2',
            '/api/v3',
            '/api/v4',
            '/api/fix_billing_payments.php',
            '/api/fix_bills.php',
            '/api/make_yokohama.php',
          ];
          let path = config.url;
          const isCsrfTokenRequired = tokenRequiredPath.some((requiredPath) => path.startsWith(requiredPath));

          if (isCsrfTokenRequired) {
            const csrfToken = localStorage.getItem('CODMON-CSRF-TOKEN');
            if (csrfToken) {
              config.headers['CODMON-CSRF-TOKEN'] = csrfToken;
            }
          }
          return config;
        },
        response: function (response) {
          if (response.headers) {
            const headers = response.headers();
            const csrfToken = headers && headers['codmon-csrf-token'];
            try {
              csrfToken && localStorage.setItem('CODMON-CSRF-TOKEN', csrfToken);
            } catch (e) {
              window.browserLogger && window.browserLogger.error('CSRFトークンの保存に失敗しました: ', {}, e);
            }
          }
          return response;
        },
        responseError: function (rejection) {
          if (rejection && rejection.status === 401 && rejection.data && rejection.data.error) {
            if (rejection.data.error.exception === 'CSRFトークンエラーが発生しました') {
              location.href = '/manage/';
            }
          }

          return $q.reject(rejection);
        },
      };
    },
  ]);

  app.config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.interceptors.push('csrfTokenInjector');
    },
  ]);

  app.config([
    '$controllerProvider',
    function ($controllerProvider) {
      app.$controllerProvider = $controllerProvider;
    },
  ]);

  function convertKeyValueArray(arr) {
    var keyValueArray = [];
    angular.forEach(arr, function (arrValue, arrKey) {
      keyValueArray.push({ key: String(arrKey), value: arrValue });
    });
    return keyValueArray;
  }

  function showErrorModal() {
    document.body.insertAdjacentHTML(
      'beforeend',
      `<div class="initializationErrorModal">
        <div class="overlay"></div>
        <div class="errorModal">
          <div class="modal-content">
            <div class="modal-header">
                <h3>ページ読み込みエラー</h3>
            </div>
            <div class="modal-body">
                コドモンのページの読込中にエラーが発生しました。通信状況をご確認の上、OKボタンを押してください。<br>※OKボタンを押すとページが再度読み込まれます
            </div>
            <div class="modal-footer">
                <button class="btn btn-success" onclick="location.reload()">OK</button>
            </div>
          </div>
        </div>
      </div>`
    );
    setTimeout(() => {
      document.querySelector('.initializationErrorModal .errorModal').classList.add('show');
    }, 100);
  }

  app
    .config(function (datepickerConfig, datepickerPopupConfig) {
      angular.extend(datepickerPopupConfig, {
        'show-button-bar': false,
      });
    })
    .run(function ($rootScope, $state) {
      $rootScope.$state = $state;
      $rootScope.codmonFeatures = window.CODMON_MANIFEST.features || {};
    });

  app.factory('commonParamsInjector', [
    '$rootScope',
    function ($rootScope) {
      var commonParamsInjector = {
        request: function (config) {
          // ファイル取得の際に実ファイルを見ていないものがパラメータを付与することで実ファイルを見に行くようになり404エラーになることに対する対処
          // APIの使用元が特定できれば良いので、ホワイトリスト形式で/api/v2/admin/hogehogeのリクエストのみパラメータを付与する。
          if (config.url.indexOf('/api/v2/admin') === 0) {
            if (!config.params) {
              config.params = {};
            }
            config.params['__env__'] = 'mgr';
            config.headers['Codmon-Current-Page'] = window.location.href.split('#').pop();
            config.headers['Codmon-Service-ID'] = $rootScope.current_serivce_id ? $rootScope.current_serivce_id : '-';
            config.headers['Codmon-Administrator-ID'] = $rootScope.current_administrator_id
              ? $rootScope.current_administrator_id
              : '-';

            const indexVer = window.CODMON_MANIFEST.versions?.index ?? '-';
            const frontVer = process.env.CODMON_APP_VERSION;
            config.headers['Codmon-App-Version'] = indexVer === frontVer ? indexVer : `${frontVer}/${indexVer}`;
          }
          return config;
        },
      };
      return commonParamsInjector;
    },
  ]);

  app.config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.interceptors.push('commonParamsInjector');
    },
  ]);

  const BUNDLE_PREFIX_V1 = window.CODMON_MANIFEST.urls.BUNDLE_PREFIX_V1;
  if (BUNDLE_PREFIX_V1) {
    app.config(function ($sceDelegateProvider) {
      // ng-include で読み込む別ドメインのURLをホワイトリストに追加
      if (!BUNDLE_PREFIX_V1.startsWith('http')) return;
      $sceDelegateProvider.resourceUrlWhitelist(['self', BUNDLE_PREFIX_V1 + '**']);
    });

    app.config(function ($provide) {
      // HTML template の URL を hash つきの URL に変換する
      const pattern = /(?:\/manage\/)?(.+?\.html?)(?:\?.+)?$/;
      const urlMap = window.CODMON_MANIFEST.imports.v1;
      if (!urlMap || !Object.keys(urlMap).length) {
        console.warn('CODMON_MANIFEST.imports.v1 is not defined or empty.');
        return;
      }

      function getHashUrlIfProvided(tpl) {
        const match = tpl.match(pattern);
        if (!match) return tpl;
        const url = urlMap[match[1]];
        if (!url) return tpl;
        return BUNDLE_PREFIX_V1 + url;
      }

      $provide.decorator('$templateRequest', function ($delegate) {
        // directive(name, function() { return { templateUrl: '...' } })
        return function (tpl, ignoreRequestError) {
          return $delegate(getHashUrlIfProvided(tpl), ignoreRequestError);
        };
      });

      $provide.decorator('$templateFactory', function ($delegate) {
        // ui-router $stateProvider.state(name, { templateUrl: '...' })
        const originalFromUrl = $delegate.fromUrl;
        $delegate.fromUrl = function (url, params) {
          return originalFromUrl.call(this, getHashUrlIfProvided(url), params);
        };
        return $delegate;
      });

      $provide.decorator('$modal', function ($delegate) {
        // $modal.open({ templateUrl: '...' })
        const originalOpen = $delegate.open;
        $delegate.open = function (modalOptions) {
          if (modalOptions && modalOptions.templateUrl) {
            return originalOpen.call(this, {
              ...modalOptions,
              templateUrl: getHashUrlIfProvided(modalOptions.templateUrl),
            });
          } else {
            return originalOpen.call(this, modalOptions);
          }
        };
        return $delegate;
      });

      $provide.decorator('customIncludeDirective', function ($delegate) {
        const directive = $delegate[0];
        const originalCompile = directive.compile;
        directive.compile = function (tElement, tAttr) {
          const originalLink = originalCompile(tElement, tAttr);
          return function (scope, element, attr) {
            attr.customInclude = getHashUrlIfProvided(attr.customInclude);
            return originalLink(scope, element, attr);
          };
        };
        return $delegate;
      });
    });
  } else {
    console.warn('CODMON_MANIFEST.urls.BUNDLE_PREFIX_V1 is not defined.');
  }

  // DOMContentLoadedとsystem取得の双方が完了していたらAngularJsを起動。
  angular.element(document).ready(function () {
    $.get('/api/v2/admin/system/')
      .done(function (data) {
        app.constant('common', {
          array_prefectures: convertKeyValueArray(data.array_prefectures),
          array_sex: convertKeyValueArray(data.array_sex),
          array_blood_type: convertKeyValueArray(data.array_blood_type),
          array_sales_status: convertKeyValueArray(data.array_sales_status),
          array_photo_sales_status: convertKeyValueArray(data.array_photo_sales_status),
          array_payment_method: convertKeyValueArray(data.array_payment_method),
          array_member_contact_relationship: convertKeyValueArray(data.array_member_contact_relationship),
        });
        app.constant('appSystem', data);
        angular.bootstrap(document, ['inspinia']);
      })
      .fail(function () {
        // 起動時に前提となるデータが取得できなかった場合はエラーを表示する
        showErrorModal();
      });
  });
})();
